module.exports = __webpack_public_path__ + "fonts/Lato-LightItalic.4d80ac57.ttf";